import { SocialAuthService } from '@abacritt/angularx-social-login';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HotToastService } from '@ngxpert/hot-toast';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from 'src/libs/api/api.service';
import { LoginHeaderService } from 'src/libs/state/login-header.service';

@Component({
  selector: 'fini-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  standalone: false,
})
export class ResetPasswordComponent implements OnInit {
  constructor(
    private api: ApiService,
    private router: Router,
    private toast: HotToastService,
    private social: SocialAuthService,
    private route: ActivatedRoute,
    private header: LoginHeaderService,
  ) {
    // Push header data up the tree
    this.header.set({
      title: 'Reset Password',
      subtitle: 'Choose a new password for your account',
    });
  }

  loading$ = new BehaviorSubject(false);
  password = '';
  confirm = '';
  resetToken = '';

  ngOnInit(): void {
    this.resetToken = this.route.snapshot.queryParams.token ?? '';
  }

  resetPassword() {
    let params: { token?: string; password: string; confirm_password: string } =
    {
      password: this.password,
      confirm_password: this.confirm,
    };

    if (this.route.snapshot.queryParams.token) {
      params.token = this.route.snapshot.queryParams.token;
    }
    if (this.resetToken !== '') {
      params.token = this.resetToken;
    }

    if (params.token === undefined) {
      this.toast.error(
        'Please provide a reset token, this can be found in the email you received.',
      );
      return;
    }

    this.loading$.next(true);
    this.api.post('reset/execute', params).subscribe((res) => {
      if (!res.success) {
        this.toast.error(res.message);
        this.loading$.next(false);
        return;
      }
      this.toast.success('Password reset successfully! Please login.');
      this.loading$.next(false);
      this.router.navigate(['/login']);
    });
  }
}
